// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cdb8d506","455":"64c62c3d"}[chunkId] + ".chunk.js";
};